export const lowerCaseRegEx: RegExp = /[a-z]/;
export const upperCaseRegEx: RegExp = /[A-Z]/;
export const numberRegEx: RegExp = /\d/;
export const specialCharacterRegEx: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/; 